var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{ref:"input",attrs:{"items":_vm.options,"label":_vm.$t('view.label.locking.lockStatus')},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})}
var staticRenderFns = []

export { render, staticRenderFns }